import { cx } from '@/util/cx';
import { accept } from '@/util/image';
import styles from './ImageUpload.module.scss';
import { useEffect, useState } from 'react';

type Props = {
  label?: string;
  onChange: (file: File) => void;
  image?: Blob | string;
  onRemove?: () => void;
  multiple?: boolean;
};

export function ImageUpload({
  onChange,
  image,
  onRemove,
  label,
  multiple,
}: Props) {
  const [src, setSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    setSrc(
      image
        ? typeof image === 'string'
          ? image
          : URL.createObjectURL(image)
        : undefined
    );
  }, [image]);

  return (
    <div className={cx(styles.DropArea, image && styles.dropped)}>
      <label
        style={
          src
            ? {
                backgroundImage: `url(${src})`,
              }
            : undefined
        }
      >
        <input
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={({ target: { files } }) => {
            if (files?.length) {
              onChange(files[0]);
            }
          }}
          onClick={(e) => {
            (e.target as HTMLInputElement).value = '';
          }}
        />

        {src ? (
          <span>Deze foto aanpassen</span>
        ) : (
          <span>
            <span className={styles.Icon} />
            <span>{label || 'Upload een eigen foto'}</span>
          </span>
        )}
      </label>

      {src && onRemove && (
        <button type="button" onClick={onRemove}>
          Deze foto verwijderen
        </button>
      )}
    </div>
  );
}
